import React, { Component } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import { bindActionCreators } from "redux";
import _ from "underscore";
import { InfoAlert, MediumPrimaryButton } from "@worthy-npm/clarity";
import GA from "lib/ga";
import WorthyApiErrors from "lib/api/worthyApiErrors";
import I18n from "lib/i18n/i18n";
import {
    isJewelers,
    isMobile,
    preloadImages,
    rootUrl,
} from "helpers/ApplicationHelper";
import SellItemWizard from "components/sellItemWizard";
import Field from "components/item/field";
import { updateSubmissionProgressState } from "actions/submissionProgress";
import { clearItem } from "actions/item";
import { newPendingItem } from "actions/pendingItem";
import { setUserFlow } from "actions/userFlow";
import { ado } from "actions/ado";
import {
    FieldBrandToSimple,
    FieldCertificateToSimple,
    FieldClarityToSimple,
    FieldColorToSimple,
    FieldMetaTypeToSimple,
    FieldShapeToSimple,
    FieldStyleToSimple,
    ItemTypes,
} from "constants/itemDetails";
import Intercom from "lib/intercom";

const ITEM_TYPES = ["ring", "bracelet"];

class NewItemForm extends Component {
    constructor(props) {
        super(props);

        const itemType = _.contains(ITEM_TYPES, this.props.params.itemType)
                ? this.props.params.itemType
                : "ring",
            fieldsToParams = () => {
                let fields = {};
                _.map(this.props.fields[itemType], (options, key) => {
                    let arrOptions = {};
                    _.map(options, (option) => {
                        arrOptions[option.name] = option.value
                            ? option.value
                            : null;
                    });
                    fields[key] = arrOptions;
                });
                return fields;
            },
            images = [
                "common/ring_setting/solitaire_white.svg",
                "common/ring_setting/loose_diamond_white.svg",
                "common/ring_setting/halo_white.svg",
                "common/ring_setting/central_cluster_white.svg",
                "common/ring_setting/bridal_set_white.svg",
                "common/ring_setting/3_stone_white.svg",
                "common/diamonds_shapes/cushion_white.svg",
                "common/diamonds_shapes/emerald_white.svg",
                "common/diamonds_shapes/heart_white.svg",
                "common/diamonds_shapes/marquise_white.svg",
                "common/diamonds_shapes/oval_white.svg",
                "common/diamonds_shapes/pear_white.svg",
                "common/diamonds_shapes/princess_white.svg",
                "common/diamonds_shapes/radiant_white.svg",
                "common/diamonds_shapes/round_white.svg",
                "common/diamond_clarity/1_white.svg",
                "common/diamond_clarity/2_white.svg",
                "common/diamond_clarity/3_white.svg",
                "common/diamond_clarity/4_white.svg",
                "common/diamond_clarity/5_white.svg",
                "common/diamond_clarity/6_white.svg",
                "common/diamond_clarity/7_white.svg",
                "common/diamond_clarity/8_white.svg",
                "common/diamond_clarity/9_white.svg",
                "common/diamond_clarity/10_white.svg",
                "common/diamond_clarity/11_white.svg",

                "common/bracelet_style/bangle_gray.svg",
                "common/bracelet_style/bangle_white.svg",
                "common/bracelet_style/charm_gray.svg",
                "common/bracelet_style/charm_white.svg",
                "common/bracelet_style/link_gray.svg",
                "common/bracelet_style/link_white.svg",
                "common/bracelet_style/slide_gray.svg",
                "common/bracelet_style/slide_white.svg",
                "common/bracelet_style/tennis_gray.svg",
                "common/bracelet_style/tennis_white.svg",

                "brands/desktop/bvlgari-black.png",
                "brands/desktop/bvlgari-white.png",
                "brands/desktop/cartier-black.png",
                "brands/desktop/cartier-white.png",
                "brands/desktop/david-yurman-black2.png",
                "brands/desktop/david-yurman-white2.png",
                "brands/desktop/harry-black.png",
                "brands/desktop/harry-white.png",
                "brands/desktop/tiffany-black.png",
                "brands/desktop/tiffany-white.png",
                "brands/desktop/van-cleef-black.png",
                "brands/desktop/van-cleef-white.png",

                "brands/bvlgari-black.png",
                "brands/bvlgari-white.png",
                "brands/cartier-black.png",
                "brands/cartier-white.png",
                "brands/david-yurman-white2.png",
                "brands/david-yurman-black2.png",
                "brands/harry-black.png",
                "brands/harry-white.png",
                "brands/tiffany-black.png",
                "brands/tiffany-white.png",
                "brands/van-cleef-black.png",
                "brands/van-cleef-white.png",
            ];

        this.state = {
            itemType,
            fields: this.props.fields[itemType],
            params: fieldsToParams(),
            valid: true,
            selectedFieldName: this.props.fields[itemType].selectedFieldName,
            filledFields: _.map(
                this.props.fields[itemType].inputs,
                (object) => {
                    return { name: object["name"], hasValue: false };
                }
            ),
            isLooseDiamond: false,
            submitFormInProcess: false,
            locationHash: __CLIENT__ && window.location.hash.slice(1),
            formSubmitted: false,
            showAlert: Boolean(
                props.location &&
                    props.location.query &&
                    props.location.query.alertMostValuable
            ),
            addedAnotherItem: false,
            addAnotherItemDisabled: true,
        };
        this.rawParams = {};
        this.sentContactDataToIntercom = false;

        preloadImages(images);

        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.validForm = this.validForm.bind(this);
        this.setValue = this.setValue.bind(this);
        this.afterKeysPressed = this.afterKeysPressed.bind(this);
        this.nextValue = this.nextValue.bind(this);
        this.setSelectedField = this.setSelectedField.bind(this);
        this.renderFields = this.renderFields.bind(this);
        this.suggestionsShown = this.suggestionsShown.bind(this);
        this.alertMostValuable = this.alertMostValuable.bind(this);
        this.getItemType = this.getItemType.bind(this);
    }

    componentWillReceiveProps({ item, Session, ADO }) {
        if (item instanceof WorthyApiErrors) {
            this.props.clearItem();
        }

        if (Session && isJewelers(Session)) {
            window.location = rootUrl("/jewelers");
        }

        if (ADO) {
            if (ADO.intercomDataEvent && !this.sentContactDataToIntercom) {
                Intercom.updateContactData(JSON.parse(ADO.intercomDataEvent));
                this.sentContactDataToIntercom = true;
            }
            if (!this.state.funnelStepEventFired) {
                this.setState({ funnelStepEventFired: true });
            }
        }
    }

    componentDidMount() {
        this.props.updateSubmissionProgressState("submission");
        this.sentContactDataToIntercom = false;
        this.props.ado();
        if (this.props.pendingItem) {
            this.setState({ params: this.props.pendingItem.params });
            this.setState({ selectedFieldName: undefined });
        }

        let userFlow = this.props.location.query.flow || "";
        console.log(`User flow value (in did mount): ${userFlow}`);
        this.props.setUserFlow(userFlow);
        console.log("User flow set in did mount");

        window.browserHistory = browserHistory;
        GA.logItemTypeVariable(this.state.itemType);
        Intercom.show();
    }

    componentWillUnmount() {
        this.props.updateSubmissionProgressState();
        if (isMobile()) {
            Intercom.hide();
        }
    }

    fireContinueBtnEvent() {}

    // gets the certificate number or certificate type.
    getCertificate(getNumber = false, returnInvalidId = false) {
        // get the relevant input field and selected certificate value for assistance.
        const key = "diamond_certificate_2";
        let field = this.state.fields.inputs.find((f) => f.name === key);
        let certificate = this.state.params.inputs[key];
        // if we don't have one of the pre-requisites, return default.
        if (!certificate || !field) {
            return getNumber
                ? null
                : params.diamondSettings.diamond_certificate;
        }
        let match = certificate.match(field.verificationRegex);
        if (match && match.length === 2) {
            // index zero is the line. index 1 is the group.
            return getNumber ? match[1] : match[0].replace(`_${match[1]}`, "");
        }
        if (certificate.endsWith("_")) {
            certificate = certificate.substring(0, certificate.length - 1);
        }
        match = certificate.match(field.noMatchRegex);
        if (match && match.length === 2) {
            // index zero is the line. index 1 is the group.
            if (getNumber && returnInvalidId) {
                return match[1];
            }
            return getNumber ? null : match[0].replace(`_${match[1]}`, "");
        }
        return getNumber ? null : certificate;
    }

    onFormSubmit(event) {
        event && event.preventDefault && event.preventDefault();
        if (this.state.formSubmitted) return;
        let params = this.state.params,
            paramsObject = {};

        // WORTHY-11308 - we need the item details as received from the user in simple regularized form.
        // this can be the first phase of refactoring out of the current [horrible] data structure we send to BE.
        const formInput = {
            itemType: this.state.itemType,
            style: FieldStyleToSimple[
                params.inputs.jewelry_style_ring_1 ||
                    params.inputs.jewelry_style_bracelet
            ],
            shape: FieldShapeToSimple[
                params.inputs.diamond_shape_2 || params.inputs.diamond_shape
            ],
            caratWeight:
                params.inputs.diamond_carat_weight_2 &&
                parseFloat(params.inputs.diamond_carat_weight_2),
            caratWeightTotal:
                params.inputs.diamond_total_carat_weight &&
                parseFloat(params.inputs.diamond_total_carat_weight),
            color:
                FieldColorToSimple[params.inputs.diamond_color_2] ||
                FieldColorToSimple[params.inputs.diamond_average_color_grade],
            clarity:
                FieldClarityToSimple[params.inputs.diamond_clarity_2] ||
                FieldClarityToSimple[
                    params.inputs.diamond_average_clarity_grade
                ],
            certificateType:
                this.state.params.inputs.diamond_certificate_2 &&
                FieldCertificateToSimple[this.getCertificate()],
            certificateId:
                (this.state.params.inputs.diamond_certificate_2 &&
                    this.getCertificate(true)) ||
                undefined,
            brand: FieldBrandToSimple[
                params.inputs.diamond_brand_2 || params.inputs.jewelry_brand
            ],
            numDiamonds: params.inputs.diamond_number_of_stones,
            metalType: FieldMetaTypeToSimple[params.inputs.jewelry_metal_type],
            submitTimestamp: new Date().toISOString(),
        };

        if (this.state.itemType === "ring") {
            if (
                params.inputs.jewelry_style_ring_1 ===
                "jewelry_style_ring_loose_diamond"
            ) {
                formInput.itemType = ItemTypes.LooseDiamond;
                delete formInput.style; // there's no style for loose diamond. see WORTHY-11307

                paramsObject = {
                    item_type: "Loose Diamonds",
                    seller_item: {
                        item_type_id: params.looseDiamondType.item_type_id,
                        desc: params.looseDiamondType.desc,
                        initial_transaction_type:
                            params.looseDiamondType.initial_transaction_type,
                        subsets: {
                            1: {
                                type: params.looseDiamondType.type_1,
                                properties_set: {
                                    item_type:
                                        params.looseDiamondType.item_type_1,
                                    diamond_color_shade:
                                        params.diamondSettings
                                            .diamond_color_shade,
                                    diamond_cut_grade:
                                        params.diamondSettings
                                            .diamond_cut_grade,
                                    diamond_polish:
                                        params.diamondSettings.diamond_polish,
                                    diamond_symmetry:
                                        params.diamondSettings.diamond_symmetry,
                                    diamond_fluorescence_intensity:
                                        params.diamondSettings
                                            .diamond_fluorescence_intensity,
                                    diamond_diamond_treated:
                                        params.diamondSettings
                                            .diamond_diamond_treated,
                                    diamond_clarity_enhanced:
                                        params.diamondSettings
                                            .diamond_clarity_enhanced,
                                    diamond_color_enhanced:
                                        params.diamondSettings
                                            .diamond_color_enhanced,
                                    diamond_chips:
                                        params.diamondSettings.diamond_chips,
                                    diamond_inclusions_location:
                                        params.diamondSettings
                                            .diamond_inclusions_location,
                                    diamond_inclusions_level:
                                        params.diamondSettings
                                            .diamond_inclusions_level,
                                    diamond_culet_size:
                                        params.diamondSettings
                                            .diamond_culet_size,
                                    diamond_culet_condition:
                                        params.diamondSettings
                                            .diamond_culet_condition,
                                    diamond_certificate: this.getCertificate(),
                                    diamond_certificate_number:
                                        this.getCertificate(true),
                                    diamond_setting_type:
                                        params.diamondSettings
                                            .diamond_setting_type,
                                    diamond_carat_weight:
                                        params.inputs.diamond_carat_weight_2,
                                    diamond_shape:
                                        params.inputs.diamond_shape_2,
                                    diamond_color:
                                        params.inputs.diamond_color_2,
                                    diamond_clarity:
                                        params.inputs.diamond_clarity_2,
                                    diamond_type:
                                        params.diamondSettings.diamond_type,
                                    // stone_type: params.diamondSettings.diamond_type
                                },
                            },
                        },
                    },
                };
            } else {
                paramsObject = {
                    item_type: "Rings",
                    seller_item: {
                        item_type_id: params.jewelryType.item_type_id,
                        desc: params.jewelryType.desc,
                        initial_transaction_type:
                            params.jewelryType.initial_transaction_type,
                        subsets: {
                            1: {
                                type: params.jewelryType.type_1,
                                properties_set: {
                                    item_type: params.jewelryType.item_type_1,
                                    jewelry_style_ring:
                                        params.inputs.jewelry_style_ring_1,
                                    ring_size: params.jewelryType.ring_size,
                                    jewelry_metal_weight:
                                        params.jewelryType.jewelry_metal_weight,
                                    jewelry_brand:
                                        params.inputs.diamond_brand_2,
                                },
                            },
                            2: {
                                type: params.jewelryType.type_2,
                                properties_set: {
                                    diamond_color_shade:
                                        params.diamondSettings
                                            .diamond_color_shade,
                                    diamond_cut_grade:
                                        params.diamondSettings
                                            .diamond_cut_grade,
                                    diamond_polish:
                                        params.diamondSettings.diamond_polish,
                                    diamond_symmetry:
                                        params.diamondSettings.diamond_symmetry,
                                    diamond_fluorescence_intensity:
                                        params.diamondSettings
                                            .diamond_fluorescence_intensity,
                                    diamond_diamond_treated:
                                        params.diamondSettings
                                            .diamond_diamond_treated,
                                    diamond_clarity_enhanced:
                                        params.diamondSettings
                                            .diamond_clarity_enhanced,
                                    diamond_color_enhanced:
                                        params.diamondSettings
                                            .diamond_color_enhanced,
                                    diamond_chips:
                                        params.diamondSettings.diamond_chips,
                                    diamond_inclusions_location:
                                        params.diamondSettings
                                            .diamond_inclusions_location,
                                    diamond_inclusions_level:
                                        params.diamondSettings
                                            .diamond_inclusions_level,
                                    diamond_culet_size:
                                        params.diamondSettings
                                            .diamond_culet_size,
                                    diamond_culet_condition:
                                        params.diamondSettings
                                            .diamond_culet_condition,
                                    diamond_certificate: this.getCertificate(),
                                    diamond_certificate_number:
                                        this.getCertificate(true),
                                    diamond_setting_type:
                                        params.diamondSettings
                                            .diamond_setting_type,
                                    diamond_carat_weight:
                                        params.inputs.diamond_carat_weight_2,
                                    diamond_shape:
                                        params.inputs.diamond_shape_2,
                                    diamond_color:
                                        params.inputs.diamond_color_2,
                                    diamond_clarity:
                                        params.inputs.diamond_clarity_2,
                                    diamond_type:
                                        params.diamondSettings.diamond_type,
                                    stone_type:
                                        params.diamondSettings.stone_type,
                                    // stone_type: params.diamondSettings.diamond_type
                                },
                            },
                        },
                    },
                };
            }
        }

        if (this.state.itemType === "bracelet") {
            paramsObject = {
                item_type: "Bracelets",
                seller_item: {
                    item_type_id: params.jewelryType.item_type_id,
                    desc: params.jewelryType.desc,
                    subsets: {
                        1: {
                            type: params.jewelryType.type_1,
                            properties_set: {
                                item_type: params.jewelryType.item_type_1,
                                jewelry_style_bracelet:
                                    params.inputs.jewelry_style_bracelet,
                                jewelry_metal_type:
                                    params.inputs.jewelry_metal_type,
                                jewelry_brand: params.inputs.jewelry_brand,
                            },
                        },
                        2: {
                            type: params.jewelryType.type_2,
                            properties_set: {
                                diamond_number_of_stones:
                                    params.inputs.diamond_number_of_stones,
                                diamond_total_carat_weight:
                                    params.inputs.diamond_total_carat_weight,
                                diamond_shape: params.inputs.diamond_shape,
                                diamond_average_clarity_grade:
                                    params.inputs.diamond_average_clarity_grade,
                                diamond_average_color_grade:
                                    params.inputs.diamond_average_color_grade,
                            },
                        },
                    },
                },
            };
        }

        const inputs = params.inputs;
        const color =
            inputs.diamond_color_2 || inputs.diamond_average_color_grade || "";
        const clarity =
            inputs.diamond_clarity_2 ||
            inputs.diamond_average_clarity_grade ||
            "";
        const weight =
            inputs.diamond_carat_weight_2 ||
            inputs.diamond_total_carat_weight ||
            "0.0";
        const knowColor = color.indexOf("not_sure") === -1;
        const knowClarity = clarity.indexOf("not_sure") === -1;
        const exactWeight = (weight.split(".")[1] || "0").length > 1;
        paramsObject["know2c"] = (knowClarity && knowColor) || exactWeight;

        if (!this.validForm()) {
            this.nextValue();
            return;
        }
        this.setState({ formSubmitted: true });

        this.fireContinueBtnEvent();

        // sometimes loading data from backend takes time. we want to make sure that ADO is loaded before we call this
        // registration section.
        let retries = 0;

        function verifySessionAndSubmit() {
            if (this.props.Session) {
                if (!this.props.Session.isLoggedIn) {
                    // this.props.newPendingItem(params, paramsObject);
                    browserHistory.push("/register");
                } else {
                    this.setState({ submitFormInProcess: true });
                }

                let userFlow = this.props.location.query.flow || "";
                paramsObject.user_flow = userFlow;
                this.props.newPendingItem(
                    params,
                    paramsObject,
                    this.props.Session.isLoggedIn,
                    formInput
                );
            } else {
                retries++;
                if (retries < 5) {
                    console.log(
                        "Session not ready. Retrying submit in 1 second. retries: " +
                            retries
                    );
                    setTimeout(verifySessionAndSubmit, 1000);
                } else {
                    throw new Error(
                        "Session not ready in time. Cannot continue submit process. "
                    );
                }
            }
        }
        verifySessionAndSubmit = verifySessionAndSubmit.bind(this);

        verifySessionAndSubmit();
    }

    validForm() {
        this.invalidField = undefined;
        let valid = true;
        // let it = this.state.itemType
        let inputs = this.state.params.inputs;
        // the loop below works for input number or select; if more are to be added, the code should be improved
        for (const key in inputs) {
            let fieldName = key.replace(/_/g, " ").replace(/ \d/, "");
            if (!inputs[key]) {
                valid = false;
                this.invalidField = this.invalidField || { name: key };
                let msg;
                if (
                    key === "diamond_carat_weight_2" &&
                    this.refs["diamond-carat-input"] &&
                    this.refs[
                        "diamond-carat-input"
                    ].refs.inputNumber.classList.contains("suggestions-visible")
                ) {
                    msg = "Carat weight too high";
                } else {
                    msg = this.rawParams[key] ? "wrong chars" : "empty";
                }
            } else {
                // even if we have a key - we still need to verify there's no additional verification
                let field = this.state.fields.inputs.find(
                    (f) => f.name === key
                );
                if (
                    typeof field.verificationRegex === "string" &&
                    !inputs[key].match(field.verificationRegex)
                ) {
                    // the value doesn't match the validation string - mark error.
                    valid = false;
                    this.invalidField = this.invalidField || { name: key };
                }
            }
        }
        valid && this.suggestionsShownFlag;
        this.setState({ valid, addAnotherItemDisabled: !valid });
        return valid;
    }

    setValue(fieldLabel, fieldValueString, fieldName, fieldValue) {
        this.invalidField = undefined;
        let params = this.state.params;
        let filledFields = this.state.filledFields;
        params.inputs[fieldName] = fieldValue;
        filledFields[
            _.pluck(filledFields, "name").indexOf(fieldName)
        ].hasValue = !!fieldValue;
        this.setState({ params });
        this.setState({ filledFields });
        if (fieldValue) {
            this.nextValue();
        }

        // change state only when in 'ring style' box
        if (fieldName === "jewelry_style_ring_1") {
            this.setState({
                isLooseDiamond:
                    fieldValue === "jewelry_style_ring_loose_diamond",
            });
        }
        if (this.validForm()) {
            this.setState({ addAnotherItemDisabled: false });
        }
        this.setState({ valid: true });
    }

    setDefaultValue(fieldName, fieldValue) {
        let params = this.state.params;
        params.inputs[fieldName] = fieldValue;
        this.setState({ params });
    }

    nextValue() {
        let nextField =
            this.invalidField ||
            _.findWhere(this.state.filledFields, { hasValue: false });
        if (nextField) {
            this.setState({ selectedFieldName: nextField.name });
            return;
        }
        this.setState({ selectedFieldName: null });
    }

    setSelectedField(fieldName) {
        let selectedFieldName = null;
        if (this.state.selectedFieldName !== fieldName) {
            selectedFieldName = fieldName;
        }
        this.setState({ selectedFieldName });
    }

    afterKeysPressed(value, field) {
        this.rawParams[field.name] = value;
    }

    renderFields(field) {
        let autoSelectOption =
            field.name === "jewelry_style_ring_1" &&
            this.state.locationHash === "Loose_Diamonds"
                ? "jewelry_style_ring_loose_diamond"
                : null;

        return (
            <Field
                ref={field.className}
                key={field.name}
                className={field.className}
                name={field.name}
                label={field.label}
                optional={field.optional}
                topText={field.topText}
                additionalText={field.additionalText}
                afterKeysPressed={(value) => {
                    this.afterKeysPressed(value, field);
                }}
                tip={field.tip}
                fieldIsFirstInvalid={
                    this.invalidField && this.invalidField.name === field.name
                }
                options={field.options ? field.options : []}
                isOpen={
                    field.name === this.state.selectedFieldName ? true : false
                }
                type={field.type}
                value={
                    this.props.pendingItem
                        ? this.props.pendingItem.params.inputs[field.name]
                        : field.value
                }
                minValue={field.minValue}
                integer={field.integer}
                onUpdateField={(value, valueString) => {
                    this.setValue(field.label, valueString, field.name, value);
                }}
                onToggleField={(fieldName) => {
                    this.setSelectedField(fieldName);
                }}
                isLooseDiamond={this.state.isLooseDiamond}
                defaultValue={field.defaultValue}
                setDefaultValue={(value) => {
                    this.setDefaultValue(field.name, value);
                }}
                scrollToOnOpen={field.scrollToOnOpen}
                submitFormInProcess={this.state.submitFormInProcess}
                autoSelectOption={autoSelectOption}
                suggestionsShown={this.suggestionsShown}
                withSuggestions={field.withSuggestions}
                verificationRegex={field.verificationRegex}
            />
        );
    }

    suggestionsShown() {
        this.suggestionsShownFlag = true;
    }

    alertMostValuable() {
        const { showAlert } = this.state;
        const itemType = this.getItemType();
        const alertText = I18n.getString(
            "submitForm::mostValubleAlert"
        ).replace("{itemType}", itemType);
        const alert = showAlert ? (
            <InfoAlert
                text={alertText}
                onClose={() => this.setState({ showAlert: false })}
                marginVsides={"md"}
            />
        ) : null;
        return <div className="jb-alert">{alert}</div>;
    }

    getItemType() {
        let { itemType, locationHash } = this.state;
        if (!itemType) {
            console.error("itemType not found!");
            itemType = "jewerly";
        } else if (itemType == "ring" && locationHash === "Loose_Diamonds") {
            itemType = "diamond";
        }
        return itemType;
    }

    addAnotherItem() {
        // This is subjected to an optimize experiment
        if (this.state.addAnotherItemDisabled) {
            return (
                <container className={"add-another-item opt-hide unvalid"}>
                    <div className={"icon unvalid"} />
                    <span className={"add-text grey"}>
                        {" "}
                        {I18n.getString("submitForm::addAnotherItem")}{" "}
                    </span>
                </container>
            );
        } else if (this.state.addedAnotherItem) {
            return (
                <container
                    className={"add-another-item opt-hide"}
                    onClick={() => {
                        this.toggleAnotherItem();
                    }}
                    data-automation="add-another-item-btn"
                >
                    <div className={"icon added"} />
                    <span className={"add-text"}>
                        {" "}
                        {I18n.getString("submitForm::haveAnotherItem")}
                    </span>
                </container>
            );
        } else {
            return (
                <container
                    className={"add-another-item opt-hide"}
                    onClick={() => {
                        this.toggleAnotherItem();
                    }}
                >
                    <div className={"icon add"} />
                    <span className={"add-text orange"}>
                        {" "}
                        {I18n.getString("submitForm::addAnotherItem")}{" "}
                    </span>
                </container>
            );
        }
    }

    toggleAnotherItem() {
        if (this.state.addedAnotherItem) {
            window.localStorage.removeItem("hasAnotherItem");
        } else {
            window.localStorage.setItem("hasAnotherItem", true);
        }
        this.setState({ addedAnotherItem: !this.state.addedAnotherItem });
    }

    render() {
        let nextField,
            fieldLabel,
            errorMessage = null,
            firstInvalidMiniField = this.invalidField;
        // let h1 = I18n.getString(`submitForm::${this.state.itemType}::title`); todo: uncomment when exp 10267 title change ends.
        let pageTitle = (
            <div>
                <h1 className={"title1"}>
                    {I18n.getString(
                        `submitForm::${this.state.itemType}::title`
                    )}
                </h1>
                <h1 className={"title2"}>DESCRIBE YOUR RING FOR AUCTION</h1>
            </div>
        );

        if (firstInvalidMiniField) {
            nextField = _.findWhere(this.state.fields.inputs, {
                name: this.invalidField.name,
            });
            fieldLabel = nextField.label;
            errorMessage = I18n.getString(
                `submitForm::errorMessage::${nextField.type}`,
                { fieldLabel: fieldLabel }
            );
            if (
                nextField.name === "diamond_carat_weight_2" &&
                this.refs[
                    "diamond-carat-input"
                ].refs.inputNumber.classList.contains("suggestions-visible")
            ) {
                errorMessage = errorMessage.replace("enter", "select / revise");
            }
            if (nextField.name === "diamond_certificate_2") {
                errorMessage = I18n.getString(
                    "submitForm::errorMessage::giaCertificteStructure"
                );
            }
        }

        return (
            <div id="submit-item-container">
                {this.alertMostValuable()}
                <SellItemWizard step={1} />
                {this.props.submissionOnHomePage ? null : pageTitle}
                <div id="submission_form_new_ui">
                    <form
                        onSubmit={this.onFormSubmit}
                        id="submit-item-form"
                        className={!this.state.valid ? "no-valid" : ""}
                        noValidate
                    >
                        {this.state.fields.inputs.map(this.renderFields)}
                        {this.addAnotherItem()}
                        <div
                            className={`alert-box ${
                                !this.state.valid ? " visible" : ""
                            }`}
                        >
                            {errorMessage}
                        </div>
                        <div className="submit-clarity-button-wrapper">
                            <MediumPrimaryButton
                                click={(stopAnimation) => {
                                    stopAnimation();
                                    this.onFormSubmit();
                                }}
                                text={I18n.getString(
                                    "submitForm::submitButton"
                                )}
                                disabled={this.state.formSubmitted}
                                overrideWrapperCSS={{
                                    width: "100%",
                                    textAlign: "center",
                                }}
                                overrideCSS={{
                                    backgroundColor: "#2D5DEC",
                                    borderRadius: "3px",
                                    width: `${isMobile() ? "100%" : "125px"}`,
                                    padding: "11px 22px 12px",
                                    font: "500 16px Roboto",
                                    marginTop: `${
                                        isMobile() ? "30px" : "60px"
                                    }`,
                                }}
                            />
                        </div>
                    </form>
                </div>
                {isMobile() ? (
                    <span className="bottom-text">
                        <span>{I18n.getString("submitForm::needHelp")}</span>
                        <a className={`help-button blue`}>
                            {I18n.getString("submitForm::clickToHelp")}
                        </a>
                    </span>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = ({
    Session,
    Form,
    Item,
    PendingItem,
    UserFlow,
    ADO,
}) => {
    return {
        Session,
        fields: Form.Fields,
        item: Item,
        pendingItem: PendingItem,
        userFlow: UserFlow,
        ADO,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            clearItem,
            newPendingItem,
            updateSubmissionProgressState,
            setUserFlow,
            ado,
        },
        dispatch
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(NewItemForm);
